import RotateButton from "./Rotate";

export default {
    button: RotateButton,
    name: "rotate",
};
